import type { FunctionComponent } from 'react';
import { MediaGalleryTimeline } from './MediaGalleryTimeline';
import { useMediaGalleryLightBoxContext } from '../../contexts/MediaGalleryLightBoxContext/MediaGalleryLightBoxContext';

export const MediaGalleryTimelineWithData: FunctionComponent = () => {
  const { propertyPageBySlugData } = useMediaGalleryLightBoxContext();
  const timeline = propertyPageBySlugData?.mediaGalleryV2?.timeline;
  if (!timeline || timeline.length === 0) return null;

  return <MediaGalleryTimeline timelines={timeline} />;
};
